<form nz-form class="form" nzLayout="horizontal" [formGroup]="organizationForm">
  <div class="drawer-form-wrapper">
    <app-search-select
      label="Search Organization"
      inputId="orgSelect"
      [control]="organizationForm.get('orgparentorg')"
      lookupType="ParentOrganization"
      placeholder="Search"
      noDataText="No organizations found"
      requiredErrorMessage="Please select a Parent Organization">
    </app-search-select>
    <nz-form-item>
      <nz-upload
        [nzFileList]="fileList"
        [nzBeforeUpload]="beforeUpload"
        [nzShowUploadList]="true"
        [nzRemove]="handleOrganizationFileRemove"
        [nzIconRender]="iconTemplate"
        nzListType="picture"
        [nzMultiple]="false"
        nzDrop
        [nzAccept]="'.xls,.xlsx'"
        class="file-upload">
        <button nz-button type="button">
          <div class="upload-icon">
            <svg-icon
              [title]="'Upload organization file'"
              src="/assets/icon/icon-upload.svg"
              class="icon s-12">
            </svg-icon>
          </div>
          <div class="wrapper">
            <p class="text s-14 fw-600 green">
              Click to upload
              <span class="text s-14 fw-400">or drag and drop</span>
            </p>
            <p class="text s-12 fw-400">XLS, XLSX files only</p>
          </div>
        </button>
        <app-upload-progress
          [progress$]="uploadProgress$"></app-upload-progress>
      </nz-upload>
    </nz-form-item>

    <div class="btn-wrapper-end">
      <a
        href="/assets/samplefiles/SampleOrgFile.xlsx"
        download="SampleOrgFile.xlsx"
        nz-button
        nzType="text"
        class="primary-text-btn">
        Sample Import File
      </a>
    </div>

    <div class="display-flex justify-content-between drawer-footer">
      <button nz-button nzType="default" (click)="closeImportDrawer()">
        Cancel
      </button>
      <button
        type="button"
        nz-button
        [nzLoading]="loading$ | async"
        (click)="customUpload()"
        [disabled]="this.fileList.length === 0"
        nzType="primary">
        Import File
      </button>
    </div>
  </div>
</form>

<ng-template #iconTemplate let-file>
  <svg-icon src="/assets/icon/icon-xls.svg" class="icon s-12"></svg-icon>
</ng-template>
